const payModule = {
  state: () => ({
    query: {}, // 首页保存参数
  }),
  mutations: {
    SET_QUERY(state, query = {}) {
      state.query = query
    }
  },
  actions: {
    setQquery({ commit }, query) {
      commit('SET_QUERY', query)
    }
  },
  getters: {  }
}

export default payModule